import React from 'react';
import { FaRecycle } from 'react-icons/fa'; // Importer les icônes nécessaires


// ButtonRecycle avec une icône de Recycler
const ButtonRecycle = ({ onClick, className = '', hoverLabel = 'Vider le groupe de ses adhérents'  }) => {
  return (
    <button
      onClick={onClick}
      aria-label={hoverLabel}
      title={hoverLabel} 
      className={`w-8 h-8 bg-orange-500 text-white rounded-md shadow-sm transition duration-300 ease-in-out hover:bg-orange-700 flex items-center justify-center ${className}`}
    >
      <FaRecycle  className='text-[12px]'/>
    </button>
  );
};

export default ButtonRecycle;
